module.exports = __webpack_public_path__ + "static/media/9.12857d01.png";